export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      style={{ background: "var(--bg-dark)", color: "var(--text-inverse)", marginTop: 96 }}
    >
      <div className="container-belle" style={{ paddingTop: 80, paddingBottom: 60 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr 1fr 1fr", gap: 48 }} className="footer-grid">
          <div>
            <img
              src="/brand/le-salon-wordmark.png"
              alt="Le Salon"
              style={{ height: 56, width: "auto", display: "block", filter: "invert(1) brightness(1.2)" }}
            />
              <p style={{ marginTop: 16, opacity: 0.7, lineHeight: 1.7, fontWeight: 300, fontSize: 14, maxWidth: 360 }}>
              A gathering place for women who love living beautifully — slowly, intentionally, and in the French style.
            </p>
            <p style={{ marginTop: 24, opacity: 0.5, fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase" }}>
              In partnership with
            </p>
            <div style={{ marginTop: 8, display: "flex", flexDirection: "column", gap: 6 }}>
              <a href="https://www.belleinspiration.com" target="_blank" rel="noreferrer" data-testid="footer-belle-link"
                style={{ color: "var(--text-inverse)", opacity: 0.85, fontSize: 14 }} className="link-underline">Belle Inspiration Magazine →</a>
              <a href="https://www.joiedevivretv.com" target="_blank" rel="noreferrer" data-testid="footer-joie-link"
                style={{ color: "var(--text-inverse)", opacity: 0.85, fontSize: 14 }} className="link-underline">Joie de Vivre TV Network →</a>
            </div>
          </div>

          <FooterCol title="The Salon" links={[
            { to: "/feed", label: "Feed" },
            { to: "/rooms", label: "Rooms" },
            { to: "/journal", label: "Letters" },
            { to: "/editors-letter", label: "Editor's Journal" },
            { to: "/messages", label: "Private Notes" },
          ]} />
          <FooterCol title="Maison" links={[
            { to: "/install", label: "Get the App" },
            { to: "/about", label: "About" },
            { to: "/guidelines", label: "Community Guidelines" },
            { to: "/privacy", label: "Privacy Policy" },
            { to: "/terms", label: "Terms & Conditions" },
          ]} />
        </div>

        <div style={{ marginTop: 64, paddingTop: 32, borderTop: "1px solid rgba(250, 249, 245, 0.12)", display: "flex", justifyContent: "space-between", opacity: 0.5, fontSize: 12, letterSpacing: "0.1em" }}>
          <span>© {new Date().getFullYear()} Le Salon</span>
          <span style={{ fontStyle: "italic", fontFamily: "'Cormorant Garamond', serif", letterSpacing: "0.05em" }}>
            A Belle Inspiration gathering.
          </span>
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, links }) => (
  <div>
    <div className="overline" style={{ color: "var(--text-inverse)", opacity: 0.6 }}>{title}</div>
    <ul style={{ marginTop: 16, listStyle: "none", padding: 0, display: "flex", flexDirection: "column", gap: 10 }}>
      {links.map((l) => (
        <li key={l.label}>
          <a href={l.to} style={{ color: "var(--text-inverse)", opacity: 0.85, fontSize: 14 }} className="link-underline">{l.label}</a>
        </li>
      ))}
    </ul>
  </div>
);
